exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-4[data-v-1aaa93b8],.col-12[data-v-1aaa93b8]{margin-bottom:20px}.card-deck .card[data-v-1aaa93b8]{margin-left:0!important;margin-right:0!important;background:#fff}.card[data-v-1aaa93b8]{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1aaa93b8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/resources/ResourceCard.vue
// module id = RJGg
// module chunks = 0